// extracted by mini-css-extract-plugin
export default {"sorting":"Sorting__sorting__SAinS","label":"Sorting__label__u6nHH","dropdown":"Sorting__dropdown__toG3R"};